import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-card',
  templateUrl: './custom-card.component.html',
  styleUrls: ['./custom-card.component.scss']
})
export class CustomCardComponent implements OnInit {

	@Input() id = -1;
	@Input() text = 'TEST';
	@Input() icon = 'edit';

	@Output() click : EventEmitter<number> = new EventEmitter<number>();

	clicked() { this.click.emit(this.id);	}

  constructor() { }

  ngOnInit(): void {
  }

}
